'use strict';

import { axiosWithToken, axiosWithoutEncryption } from '../utils/functions/apiCallWithToken';
import { SERVER_URL as API } from '../core/config';


/**
 * Resolve a referral code — public endpoint.
 * @param {string} code
 * @returns {Promise<{ username: string }>}
 */
export const resolveReferralCode = (code) =>
  axiosWithoutEncryption(`${API}/referral/resolve?code=${encodeURIComponent(code)}`, 'get', {});

/**
 * Get current user's referral info (code, link, stats).
 * @returns {Promise<{ code, link, stats }>}
 */
export const getMyReferral = () =>
  axiosWithToken(`${API}/referral/me`, 'get', {});

/**
 * Get current user's referral history.
 * @param {{ page?: number, limit?: number }} opts
 * @returns {Promise<{ total, page, referrals }>}
 */
export const getReferralHistory = ({ page = 1, limit = 20 } = {}) =>
  axiosWithToken(`${API}/referral/history?page=${page}&limit=${limit}`, 'get', {});

/**
 * Get the list of invited prospects (emails) with their accepted/pending status.
 * @returns {Promise<{ prospects: { email, joined, invitedAt }[] }>}
 */
export const getProspects = () =>
  axiosWithToken(`${API}/referral/prospects`, 'get', {});

/**
 * Resend an invitation to a pending prospect (max 3 resends, then blocked).
 * @param {string} email
 * @returns {Promise<{ message, resendCount, remaining }>}
 */
export const resendInvite = (email) =>
  axiosWithToken(`${API}/referral/prospects/resend`, 'post', { email });

/**
 * Send email invitations to one or more friends (max 10, sent in parallel server-side).
 * @param {string|string[]} emails
 * @returns {Promise<{ sent: number, message: string }>}
 */
export const sendReferralInvite = (emails) =>
  axiosWithToken(`${API}/referral/invite`, 'post', {
    emails: Array.isArray(emails) ? emails : [emails],
  });
